"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCookieConsentBanner = exports.shouldAddCookieConsentBanner = exports.getCookieConsentBannerExtraQueryParam = void 0;
var config_1 = __importDefault(require("../../build-babel/auth/client/config"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var URL_GET_PARAM_NAME = 'disableCookieConsentBanner';
var DISABLE_COOKIE_CONSENT_COOKIE_NAME = 'disableCookieConsentBanner';
var setDisableCookieConsentCookie = function setDisableCookieConsentCookie(disableCookieConsentBanner) {
  js_cookie_1["default"].set(DISABLE_COOKIE_CONSENT_COOKIE_NAME, disableCookieConsentBanner.toString());
};
var getDisableCookieConsentCookie = function getDisableCookieConsentCookie() {
  var cookie = js_cookie_1["default"].get(DISABLE_COOKIE_CONSENT_COOKIE_NAME);
  return !!(cookie && cookie === 'true');
};
var getCookieConsentBannerExtraQueryParam = function getCookieConsentBannerExtraQueryParam() {
  if (!(0, exports.shouldAddCookieConsentBanner)()) {
    return _defineProperty({}, URL_GET_PARAM_NAME, 'true');
  }
};
exports.getCookieConsentBannerExtraQueryParam = getCookieConsentBannerExtraQueryParam;
var shouldAddCookieConsentBanner = function shouldAddCookieConsentBanner() {
  var urlParams = new URLSearchParams(window.location.search);
  var disableCookieConsentBannerParam = urlParams.get(URL_GET_PARAM_NAME);
  if (disableCookieConsentBannerParam === null) {
    return !getDisableCookieConsentCookie();
  }
  var disableCookieConsentBanner = !!(disableCookieConsentBannerParam && disableCookieConsentBannerParam === 'true');
  setDisableCookieConsentCookie(disableCookieConsentBanner);
  return !disableCookieConsentBanner;
};
exports.shouldAddCookieConsentBanner = shouldAddCookieConsentBanner;
var addCookieConsentBanner = function addCookieConsentBanner() {
  var envConfig = (0, config_1["default"])();
  if (envConfig) {
    var cookieBannerScript = document.createElement('script');
    cookieBannerScript.src = "".concat(envConfig.globalFrontendScripts, "/cookieBanner.js");
    document.head.appendChild(cookieBannerScript);
  }
};
exports.addCookieConsentBanner = addCookieConsentBanner;
//# sourceMappingURL=index.js.map